import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";

import admin from "./admin";
import auth from "./auth";
import cart from "./cart";
import event from "./event";
import firestore from "./firestore";
import flowerStand from "./flowerStand";
import live from "./live";
import loading from "./loading";
import menu from "./menu";
import modal from "./modal";
import news from "./news";
import notification from "./notification";
import purchase from "./purchase";
import streaming from "./streaming";
import ticket from "./ticket";
import voucher from "./voucher";

import type { adminState } from "./admin";
import type { authState } from "./auth";
import type { cartState } from "./cart";
import type { eventState } from "./event";
import type { firestoreState } from "./firestore";
import type { flowerStandState } from "./flowerStand";
import type { liveState } from "./live";
import type { loadingState } from "./loading";
import type { menuState } from "./menu";
import type { modalState } from "./modal";
import type { newsState } from "./news";
import type { notificationState } from "./notification";
import type { purchaseState } from "./purchase";
import type { streamingState } from "./streaming";
import type { ticketState } from "./ticket";
import type { VoucherState } from "@spwn/types";
import type { RouterState } from "connected-react-router";
import type { History } from "history";

type AppState = {
  router: RouterState;
  menu: menuState;
  event: eventState;
  ticket: ticketState;
  flowerStand: flowerStandState;
  cart: cartState;
  firestore: firestoreState;
  auth: authState;
  modal: modalState;
  loading: loadingState;
  purchase: purchaseState;
  admin: adminState;
  live: liveState;
  streaming: streamingState;
  news: newsState;
  notification: notificationState;
  voucher: VoucherState;
};

const reducers = (history: History) =>
  combineReducers<AppState>({
    router: connectRouter(history),
    menu,
    event,
    ticket,
    flowerStand,
    cart,
    firestore,
    auth,
    modal,
    loading,
    purchase,
    admin,
    live,
    streaming,
    news,
    notification,
    voucher,
  });

export default reducers;
